import type { ICsrfTokenService } from '@flippingbook/web.utils/dist/csrf';

export const csrfTokenService: ICsrfTokenService = {
    get: () => window.__flippingbook_csrf__,
};
